import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Operator } from "@/shared/model/Operator";
import { getSYOperators } from "@/pages/sy/repositories/ChargeRepository";
export const useSYOperators = () => {
  const [dismissedError, setDismissedError] = useState(false);

  const { data, isLoading, error } = useQuery<Operator[]>({
    queryKey: ["operators"],
    queryFn: async ({ signal }) => {
      const response = await getSYOperators(signal);
      if (!response.ok) {
        throw new Error(response.message || "Failed to load SY operators");
      }
      return response.data?.tables?.[0]?.rows || [];
    },
  });

  const errorMessage =
    !dismissedError && error
      ? error instanceof Error
        ? error.message
        : String(error)
      : "";

  return {
    syOperators: data ?? [],
    loading: isLoading,
    error: errorMessage,
    setError: (_msg: string) => setDismissedError(!_msg),
  };
};
